import React from 'react'
import { alpha, styled } from "@mui/material/styles";
import { pink } from "@mui/material/colors";
import Switch from "@mui/material/Switch";

const PinkSwitch = styled(Switch)(({ theme }) => ({
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#fff",
      "&:hover": {
        backgroundColor: alpha("#9B1E26", theme.palette.action.hoverOpacity)
      }
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#9B1E26",
      opacity:1
    }
  }));
  
  const label = { inputProps: { "aria-label": "Color switch demo" } };
  
function SwitchButton() {
    
  return (
    <div>
       <PinkSwitch {...label} defaultChecked />
    </div>
  )
}

export default SwitchButton
